import React from 'react';
import HeroSection from './components/HeroSection';
import ProjectsSection from './components/ProjectsSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-dark-900 text-white font-heebo relative">
      {/* Background with fixed positioning and forced full viewport coverage */}
      <div 
        className="fixed top-0 left-0 right-0 bottom-0 w-screen h-screen z-0"
        style={{
          backgroundImage: 'url(/background.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          backgroundRepeat: 'no-repeat',
          transform: 'translate3d(0,0,0)',
          WebkitTransform: 'translate3d(0,0,0)',
          height: '100vh',
          minHeight: '-webkit-fill-available'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-dark-900/70 to-dark-900/90" />
      </div>

      {/* Content */}
      <main className="relative z-10">
        <HeroSection />
        <ProjectsSection />
        <ServicesSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App; 